// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__pZE3P","inputWrap":"Table_inputWrap__39MAn","col":"Table_col__1zPfg","bmiTooltip":"Table_bmiTooltip__1lK3X"};